import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Navigation.css'

export const Navigation: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const location = useLocation()

    const isActive = (path: string) => location.pathname === path

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    const closeMenu = () => {
        setIsMenuOpen(false)
    }

    return (
        <nav className="navigation">
            <div className="nav-container">
                <Link to="/" className="nav-logo" onClick={closeMenu}>
                    <span className="nav-logo-text">modern artillery group</span>
                </Link>

                <div className={`nav-menu ${isMenuOpen ? 'nav-menu--open' : ''}`}>
                    <Link
                        to="/"
                        className={`nav-link ${isActive('/') ? 'nav-link--active' : ''}`}
                        onClick={closeMenu}
                    >
                        HOME
                    </Link>
                    <Link
                        to="/shop"
                        className={`nav-link ${isActive('/shop') ? 'nav-link--active' : ''}`}
                        onClick={closeMenu}
                    >
                        SHOP
                    </Link>
                    <Link
                        to="/about"
                        className={`nav-link ${isActive('/about') ? 'nav-link--active' : ''}`}
                        onClick={closeMenu}
                    >
                        ABOUT
                    </Link>
                </div>

                <div className="nav-actions">
                    <button
                        className={`nav-toggle ${isMenuOpen ? 'nav-toggle--open' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle navigation menu"
                    >
                        <span className="nav-toggle-line"></span>
                        <span className="nav-toggle-line"></span>
                        <span className="nav-toggle-line"></span>
                    </button>
                </div>
            </div>
        </nav>
    )
}
